import React from 'react';
import { useAppContext } from '../context/AppContext';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft } = FiIcons;

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="font-black uppercase tracking-widest mb-4" style={{ color: '#ff00cc', fontSize: '14px' }}>
      {title}
    </h2>
    <div className="space-y-3" style={{ color: '#9ca3af', fontSize: '15px', lineHeight: '1.75' }}>
      {children}
    </div>
  </div>
);

export default function PrivacyPage() {
  const { setCurrentPage } = useAppContext();

  return (
    <div className="min-h-screen" style={{ background: '#080012', fontFamily: 'Courier New, monospace', color: '#fff' }}>
      <div className="max-w-2xl mx-auto px-6 py-12 pb-24">
        <button onClick={() => setCurrentPage('home')}
          className="flex items-center gap-2 text-pink-500 hover:text-pink-300 transition-colors font-bold uppercase tracking-widest mb-10"
          style={{ fontSize: '13px' }}>
          <FiArrowLeft /> Back to Grid
        </button>

        <h1 className="font-black uppercase mb-2 leading-none"
          style={{ color: '#ff00cc', fontFamily: 'Impact,sans-serif', letterSpacing: '3px', fontSize: 'clamp(32px,6vw,56px)' }}>
          Privacy Policy
        </h1>
        <p className="mb-10" style={{ color: '#4b5563', fontSize: '13px' }}>Last updated: January 2026</p>

        <Section title="1. Information We Collect">
          <p>When you purchase pixels, we collect your email address, payment information (processed securely by Stripe), and the content you submit for display on the grid (title, URL, image).</p>
          <p>We automatically collect basic usage data including your IP address, browser type, and pages visited to help us improve the service.</p>
        </Section>

        <Section title="2. How We Use Your Information">
          <p>Your information is used solely to process your purchase, display your pixel block on the grid, and send you transactional emails related to your purchase.</p>
          <p>We do not sell, rent, or share your personal data with third parties for marketing purposes.</p>
        </Section>

        <Section title="3. Cookies">
          <p>We use essential cookies to keep you signed in and remember your session. No third-party tracking or advertising cookies are used.</p>
        </Section>

        <Section title="4. Data Retention">
          <p>Your pixel block and associated data are stored permanently as part of the product — that is the core promise. Account data is retained as long as your account exists. You may request deletion of your account at any time by contacting us.</p>
        </Section>

        <Section title="5. Security">
          <p>All data is transmitted over HTTPS. Payments are handled by Stripe and we never store raw card details. We use Supabase with row-level security to protect your account data.</p>
        </Section>

        <Section title="6. Your Rights">
          <p>You have the right to access, correct, or delete your personal data. To exercise these rights, contact us at the email listed below. Note that deleting your account does not remove your pixel block from the public grid.</p>
        </Section>

        <Section title="7. Contact">
          <p>Questions about this policy? Email us at <span style={{ color: '#ff00cc' }}>privacy@1millionpixels.com</span></p>
        </Section>

        <div className="mt-8 pt-6 border-t border-pink-500/10">
          <button onClick={() => setCurrentPage('terms')}
            className="text-sm font-bold transition-colors hover:text-pink-400"
            style={{ color: '#6b7280' }}>
            View Terms of Service →
          </button>
        </div>
      </div>
    </div>
  );
}